import { BrowserRouter, Routes, Route } from "react-router-dom";

//page &layout imports
import Homepage from "./pages/Homepage";
import Legal from "./pages/Legal";
import PersonalData from "./pages/PersonalData";

//Import Simplebar styles
import "simplebar-react/dist/simplebar.min.css";

window.$host = "";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/case/:slug" element={<Homepage />}></Route>
        <Route path="/legal" element={<Legal />}></Route>
        <Route path="/personaldata" element={<PersonalData />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
